import React from "react";
import Toggle from "material-ui/Toggle";
import ToggleButton from "@techsoftware/happay-widgets/ToggleButton";

export default class CustomToggle extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { lableText, isWidgetComp } = this.props;
        if (isWidgetComp) {
            return (
                <div className="flex-vertical-center">
                    {lableText && <lable>{lableText}</lable>}
                    <ToggleButton {...this.props} />
                </div>
            );
        }
        return (
            <Toggle
                {...this.props}
                //style={{backgroundColor: '#62d2a2'}}
                //thumbStyle={{backgroundColor: '#ffffff',width: '12px',height: '12px',top: '5.5px',left: '4px',margin:0}}
                //thumbSwitchedStyle ={{backgroundColor: '#ffffff',width: '12px',height: '12px',top: '5.5px',left: '64%',margin:0}}
                //trackStyle={{backgroundColor: '#e8edf4',width: '30px',borderRadius: '100px',height: '15px',margin:0}}
                //trackSwitchedStyle ={{backgroundColor: '#62d2a2',width: '30x',borderRadius: '100px',height: '15px',margin:0}}

                //thumbStyle={{backgroundColor: '#ffffff',width: '16px',height: '16px',top: '5.5px',left: '4px',}}
                //thumbSwitchedStyle ={{backgroundColor: '#ffffff',width: '16px',height: '16px',top: '5.5px',left: '64%'}}
                //trackStyle={{backgroundColor: '#e8edf4',width: '40px',borderRadius: '100px',height: '20px'}}
                //trackSwitchedStyle ={{backgroundColor: '#62d2a2',width: '40px',borderRadius: '100px',height: '20px'}}
                thumbStyle={{
                    backgroundColor: "#ffffff",
                    width: "14px",
                    height: "14px",
                    top: "5.5px",
                    left: "4px"
                }}
                thumbSwitchedStyle={{
                    backgroundColor: "#ffffff",
                    width: "14px",
                    height: "14px",
                    top: "5.5px",
                    left: "64%"
                }}
                trackStyle={{
                    backgroundColor: "#a1abb3",
                    width: "36px",
                    borderRadius: "100px",
                    height: "18px"
                }}
                trackSwitchedStyle={{
                    backgroundColor: "#1D7CBF",
                    width: "36px",
                    borderRadius: "100px",
                    height: "18px"
                }}
            ></Toggle>
        );
    }
}
